import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';

export default function ScreeningSuccess() {
  return (
    <Box maxWidth={480} mx="auto" mt={6} px={2} textAlign="center">
      <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        Payment successful
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Your tenant screening payment was completed. The screening provider will process your request.
      </Typography>
      <Button variant="contained" href="/" sx={{ mt: 2 }}>
        Return to app
      </Button>
    </Box>
  );
}
